export const maxCharactersToString = (value, max = 50) => {
  if (typeof value === 'string') {
    const stringSlice = value.slice(0, max)
    return stringSlice
  }
  return value
}
